export * from  './XHTTPManager';
export * from  './Annotation';
export * from  './Decorators';
export * from  './Services';
export * from  './Result';

import xhttpManager from  './XHTTPManager';
export default xhttpManager;